import getConfig from 'next/config';
import {DateFormat} from '~/src/utilities/constants/formats';

const {publicRuntimeConfig: config} = getConfig();

const toLocalIsoString = (date: Date): string => {
    const tzo = -date.getTimezoneOffset();
    const dif = tzo >= 0 ? '+' : '-';
    const pad = (num: number) => {
        const norm = Math.floor(Math.abs(num));
        return (norm < 10 ? '0' : '') + norm;
    };
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
    )}${dif}${pad(tzo / 60)}:${pad(tzo % 60)}`;
};

const convertDate = (dateString: string): string => new Date(dateString).toLocaleDateString(config.localeCode, config.dateFormat);

const getLocalTimestamp = (dateString: string): string => toLocalIsoString(new Date(dateString));

const formatDateString = (dateString: string, format = DateFormat.DATE_AND_WEEKDAY): string => {
    const date = new Date(dateString);
    return formatDate(date, format);
};

const formatDate = (date: Date, format = DateFormat.DATE_AND_WEEKDAY): string => {
    switch (format) {
        case DateFormat.DATE_AND_WEEKDAY:
            const day = date.toLocaleDateString(config.localeCode, {weekday: 'long'});
            const dayString = day.charAt(0).toUpperCase() + day.slice(1);
            return `${dayString}, ${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
        case DateFormat.DATE_MONTH_LONG:
            const month = date.toLocaleDateString(config.localeCode, {month: 'long'});
            return `${date.getDate()}. ${month} ${date.getFullYear()}`;
        default:
            return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
    }
};

const formatTimestamp = (dateString: string): string =>
    new Date(dateString).toLocaleTimeString(config.localeCode, {
        hour: '2-digit',
        minute: '2-digit'
    });

export {convertDate, getLocalTimestamp, formatDate, formatDateString, formatTimestamp};
